// getFFT.js
var GetFft = pc.createScript('getFft');

// initialize code called once per entity

GetFft.attributes.add('channel', {type:'number'});
GetFft.attributes.add('scalator', {type:'number'});

GetFft.prototype.initialize = function() {
    vis = this.app.root.findByName('visualizer');
    this.scaler = 0;
    this.startScale = this.entity.getLocalScale().x;
    this.uniform = 0;
};

// update code called every frame
GetFft.prototype.update = function(dt) {
    //console.info(this.analyser.script.analyser.freqData);
    //console.info(vis.script.visualizer.analyser.script.analyser.freqData[0]);
    this.scaler = vis.script.visualizer.analyser.script.analyser.freqData[this.channel] / this.scalator;
    this.uniform = this.startScale + this.scaler;
    this.entity.setLocalScale(this.uniform, this.uniform,this.uniform);
};

// swap method called for script hot-reloading
// inherit your script state here
// GetFft.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// https://developer.playcanvas.com/en/user-manual/scripting/

